const genericErrors = {
  "error.unknown": "Unknown error",
  "error.network": "Network error",
  "error.unauthorized": "Unauthorized",
  "error.forbidden": "Forbidden",
  "error.notFound": "Not found",
  "error.badRequest": "Bad request",
  "error.unprocessableEntity": "Unprocessable entity",
  "error.internalServerError": "Internal server error",
  "error.notImplemented": "Not implemented",
};

const cardError = {
  "error.card.incorrect_card_type": "Please try again with a Mastercard or Visa card",
  "error.card.generic": "Please try a different card."
};

const internalErrorCodeTranslations = {
  "i_000": "An error occurred",
  "i_001": "The server did not accept the request because the 'Accept' header is not set to 'application/json'",

  // Auth scope
  "i_auth_001": "User already exists",
  "i_auth_002": "User not found",
  "i_auth_003": "Wrong email or password",
  "i_auth_004": "Token does not have the required abilities",
  "i_auth_005": "Too many requests",

  // Password management
  "i_pass_001": "User not found",
  "i_pass_002": "Token is invalid",
  "i_pass_003": "Too many requests",

  // Client scope
  "i_client_001": "Missing confirmation parameter to destroy client",

  // Program scope
  "i_program_001": "Missing confirmation parameter to destroy program",
  "i_program_002": "Invalid program type",
  "i_program_003": "Program not found",

  // Platform scope
  "i_platform_001": "Platform not found",
  "i_platform_002": "Platform missing mappings",

  // Membership scope
  "i_member_001": "Membership already exists",
  "i_member_002": "Membership not found",
  "i_member_003": "Value should be greater than 20",
  "i_member_004": "Value should be less than {max}",

  // Card scope
  "i_card_001": "Card membership not found",
  "i_card_002": "Card membership has no contributions",
  "i_card_003": "Card already linked to an olive account",
  "i_card_004": "Invalid user or card details",
  "i_card_005": "The Membership Tier does not exist",
  "i_card_006": "The Membership Tier Plan does not exist",
  "i_card_007": "Failed transaction. Please, check your card details and try again.",
  "i_card_008": "You have only one active card linked to your account.",

  // Reward scope
  "i_reward_001": "Bad query for reward search",

  // Theme scope
  "i_theme_001": "Theme already exists",
  "i_theme_002": "Theme not found",
  "i_theme_003": "Missing confirmation parameter to destroy theme",

  // Membership Subscription scope
  "i_membership_subscription_001": "Membership subscription payment failed",
  "i_membership_subscription_002": "Membership subscription upgrade payment failed",

  // User scope
  "i_user_001": "The password you entered doesn't match our records.",
  "i_user_002": "The email you entered doesn't match our records.",
  "i_user_003": "The password you entered doesn't match our records.",
  "i_user_004": "Your desired email address is already in use.",
}

const externalErrorCodeTranslations = {
  "e_000": "An error occurred",
  "e_olive_400": "Bad request",
  "e_olive_401": "Unauthorized",
  "e_olive_403": "Forbidden",
  "e_olive_404": "Not found",
  "e_olive_500": "Internal server error",
  "e_olive_503": "Service unavailable",

  "olive_cc_001": "We currently don’t support Discover cards",
  "olive_cc_002": "We currently don’t support Amex cards",
  "olive_cc_003": "This card is already enrolled in the program. Please use a different card or contact support at {email}.",

}

export default {
  ...genericErrors,
  ...cardError,
  ...internalErrorCodeTranslations,
  ...externalErrorCodeTranslations,
};
